export default __webpack_public_path__ + "static/media/cloth_05.5f7dab92.jpg";